import { render, staticRenderFns } from "./GItemStoryForm.vue?vue&type=template&id=647642b2&scoped=true&"
import script from "./GItemStoryForm.vue?vue&type=script&lang=ts&"
export * from "./GItemStoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./GItemStoryForm.vue?vue&type=style&index=0&id=647642b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647642b2",
  null
  
)

export default component.exports